export const COLORS = ['#3b82f6', '#8b5cf6', '#f59e0b', '#10b981', '#ef4444', '#06b6d4'];

export const formatDateFor = (language) => (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleDateString(language === 'tr' ? 'tr-TR' : 'en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatCurrency = (amount, currency = 'TRY') => {
  const symbols = { TRY: '₺', USD: '$', EUR: '€' };
  return `${symbols[currency] || ''}${amount?.toLocaleString() || 0}`;
};
